// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* obecné styly pro filtry v Playgrounds */\n/* -> TODO: extraktovat filtry do samostatne komponenty (FiltersContainer a FilterSelect) */\n\n.filters__button--doctors {\n  background-color: #512fd8;\n  color: white;\n}\n\n.filters__button--doctors:hover {\n  background-color: rgba(240, 240, 240);\n  color: black;\n}\n", ""]);
// Exports
module.exports = exports;
